/* MIO ATHLETICS — interactividad (vanilla, sin librerías) */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(pointer: fine)').matches;
  var money = function (cents) {
    var fmt = (window.MioMoneyFormat || 'RD${{amount}}');
    var v = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, v);
  };

  /* ---------- Reveal al hacer scroll ---------- */
  var io = null;
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.mio-reveal:not(.mio-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('mio-visible'); }); return; }
    if (!io) io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('mio-visible'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Inclinación 3D al cursor ---------- */
  function initTilt(root) {
    if (!fine || reduce) return;
    (root || document).querySelectorAll('[data-mio-tilt]').forEach(function (el) {
      if (el.__tilt) return; el.__tilt = true;
      var max = parseFloat(el.getAttribute('data-mio-tilt')) || 10;
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
        el.style.setProperty('--ry', ((x - 0.5) * max * 2).toFixed(2) + 'deg');
        el.style.setProperty('--rx', ((0.5 - y) * max * 2).toFixed(2) + 'deg');
        el.style.setProperty('--gx', (x * 100).toFixed(1) + '%');
        el.style.setProperty('--gy', (y * 100).toFixed(1) + '%');
      });
      el.addEventListener('pointerleave', function () { el.style.setProperty('--rx', '0deg'); el.style.setProperty('--ry', '0deg'); });
    });
  }

  /* ---------- Hero: carrusel de camisetas ---------- */
  function initHero(root) {
    (root || document).querySelectorAll('[data-mio-hero]').forEach(function (hero) {
      if (hero.__init) return; hero.__init = true;
      var slides = hero.querySelectorAll('.mio-slide');
      var dots = hero.querySelectorAll('.mio-dot');
      var bar = hero.querySelector('.mio-progress i');
      var delay = (parseFloat(hero.getAttribute('data-speed')) || 5) * 1000;
      var auto = hero.getAttribute('data-auto') === 'true';
      var i = 0, timer;
      hero.style.setProperty('--mio-dur', delay / 1000 + 's');
      function go(n) {
        if (!slides.length) return;
        var prev = slides[i];
        i = (n + slides.length) % slides.length;
        if (prev !== slides[i]) { prev.classList.remove('is-active'); prev.classList.add('is-leaving'); setTimeout(function () { prev.classList.remove('is-leaving'); }, 900); }
        slides[i].classList.add('is-active');
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
        if (bar) { bar.classList.remove('run'); void bar.offsetWidth; if (auto && slides.length > 1) bar.classList.add('run'); }
        restart();
      }
      function restart() { clearTimeout(timer); if (auto && slides.length > 1 && !reduce) timer = setTimeout(function () { go(i + 1); }, delay); }
      dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
      var p = hero.querySelector('[data-prev]'), nx = hero.querySelector('[data-next]');
      if (p) p.addEventListener('click', function () { go(i - 1); });
      if (nx) nx.addEventListener('click', function () { go(i + 1); });
      // swipe
      var sx = null, stage = hero.querySelector('.mio-stage__slides');
      if (stage) {
        stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
        stage.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1)); sx = null; });
      }
      // foco de luz + palabra de fondo
      if (fine && !reduce) {
        hero.addEventListener('pointermove', function (e) {
          var r = hero.getBoundingClientRect();
          hero.style.setProperty('--mx', (e.clientX - r.left) + 'px');
          hero.style.setProperty('--my', (e.clientY - r.top) + 'px');
        });
      }
      if (!reduce) {
        var word = hero.querySelector('.mio-hero__bgword');
        var k = parseFloat(hero.getAttribute('data-parallax')) || 0;
        if (word && k) window.addEventListener('scroll', function () { word.style.setProperty('--mio-px', (window.scrollY * k / 10).toFixed(1)); }, { passive: true });
      }
      go(0);
    });
  }

  /* ---------- Categorías: brillo que sigue al cursor ---------- */
  function initGlow(root) {
    if (!fine) return;
    (root || document).querySelectorAll('.mio-cat').forEach(function (el) {
      if (el.__glow) return; el.__glow = true;
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        el.style.setProperty('--cx', (e.clientX - r.left) + 'px');
        el.style.setProperty('--cy', (e.clientY - r.top) + 'px');
      });
    });
  }

  /* ---------- Vitrina: filtros ---------- */
  function initFilters(root) {
    (root || document).querySelectorAll('[data-mio-filters]').forEach(function (wrap) {
      if (wrap.__init) return; wrap.__init = true;
      var sec = wrap.closest('.mio-section');
      var cards = sec.querySelectorAll('.mio-card');
      var empty = sec.querySelector('.mio-empty');
      wrap.querySelectorAll('.mio-filter').forEach(function (btn) {
        btn.addEventListener('click', function () {
          wrap.querySelectorAll('.mio-filter').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          var words = (btn.getAttribute('data-filter') || '').toLowerCase().split(',').map(function (s) { return s.trim(); }).filter(Boolean);
          var shown = 0;
          cards.forEach(function (c) {
            var hay = (c.getAttribute('data-search') || '').toLowerCase();
            var ok = !words.length || words.some(function (w) { return hay.indexOf(w) > -1; });
            c.classList.toggle('is-hidden', !ok);
            if (ok) { shown++; c.classList.remove('mio-visible'); void c.offsetWidth; c.classList.add('mio-visible'); }
          });
          if (empty) empty.style.display = shown ? 'none' : 'block';
        });
      });
    });
  }

  /* ---------- Añadir al carrito (AJAX) ---------- */
  function toast(msg) {
    var t = document.querySelector('.mio-toast');
    if (!t) { t = document.createElement('div'); t.className = 'mio-toast'; document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(t.__h); t.__h = setTimeout(function () { t.classList.remove('is-on'); }, 2600);
  }
  function refreshCart() {
    var drawer = document.querySelector('cart-drawer');
    fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart.js' : '/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach(function (s) { s.textContent = cart.item_count; });
      var icon = document.getElementById('cart-icon-bubble');
      if (icon && !icon.querySelector('.cart-count-bubble') && cart.item_count) {
        var b = document.createElement('div'); b.className = 'cart-count-bubble'; b.innerHTML = '<span aria-hidden="true">' + cart.item_count + '</span>'; icon.appendChild(b);
      }
    });
    if (drawer) {
      fetch('/?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) {
        if (typeof drawer.renderContents === 'function') {
          try { drawer.renderContents({ sections: s }); drawer.classList.remove('is-empty'); } catch (e) {}
        }
      }).catch(function () {});
    }
  }
  function initAjaxAdd(root) {
    (root || document).querySelectorAll('form[data-mio-add]').forEach(function (form) {
      if (form.__init) return; form.__init = true;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[type=submit]');
        var label = btn ? btn.innerHTML : '';
        if (btn) { btn.disabled = true; btn.textContent = form.getAttribute('data-adding') || 'Agregando…'; }
        fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (!res.ok) { toast(res.j.description || 'No se pudo agregar'); return; }
            toast(form.getAttribute('data-added') || '¡Agregado al carrito!');
            refreshCart();
          })
          .catch(function () { form.submit(); })
          .finally(function () { if (btn) { btn.disabled = false; btn.innerHTML = label; } });
      });
    });
  }

  /* ---------- Calculadora de tallas ---------- */
  function initSizer(root) {
    (root || document).querySelectorAll('[data-mio-sizer]').forEach(function (box) {
      if (box.__init) return; box.__init = true;
      var h = box.querySelector('[name=altura]'), w = box.querySelector('[name=peso]');
      var hOut = box.querySelector('[data-out=altura]'), wOut = box.querySelector('[data-out=peso]');
      var res = box.querySelector('.mio-result__size'), txt = box.querySelector('[data-result-text]');
      var fitBtns = box.querySelectorAll('.mio-fit button');
      var sizes = (box.getAttribute('data-sizes') || 'S,M,L,XL').split(',').map(function (s) { return s.trim(); });
      var cuts = (box.getAttribute('data-cuts') || '64,74,84').split(',').map(Number);
      var tall = parseFloat(box.getAttribute('data-tall')) || 183;
      var fit = 0, last = '';
      var wrapS = box.closest('.mio-sizes');
      var table = wrapS && wrapS.querySelectorAll('.mio-table tbody tr');
      function pct(el) { return ((el.value - el.min) / (el.max - el.min) * 100) + '%'; }
      function calc() {
        var kg = +w.value, cm = +h.value, idx = 0;
        while (idx < cuts.length && kg >= cuts[idx]) idx++;
        if (cm >= tall) idx++;
        idx += fit;
        idx = Math.max(0, Math.min(sizes.length - 1, idx));
        var s = sizes[idx];
        hOut.textContent = cm + ' cm'; wOut.textContent = kg + ' kg';
        h.style.setProperty('--p', pct(h)); w.style.setProperty('--p', pct(w));
        if (s !== last) { res.textContent = s; res.classList.remove('pop'); void res.offsetWidth; res.classList.add('pop'); last = s; }
        if (txt) txt.textContent = (box.getAttribute('data-msg') || 'Te recomendamos la talla {talla}.').replace('{talla}', s);
        if (table) table.forEach(function (tr) { tr.classList.toggle('is-match', (tr.getAttribute('data-size') || '').toUpperCase() === s.toUpperCase()); });
      }
      [h, w].forEach(function (el) { el.addEventListener('input', calc); });
      fitBtns.forEach(function (b) { b.addEventListener('click', function () { fitBtns.forEach(function (x) { x.classList.remove('is-active'); }); b.classList.add('is-active'); fit = parseInt(b.getAttribute('data-fit'), 10) || 0; calc(); }); });
      calc();
    });
  }

  /* ---------- Producto ---------- */
  function initPdp(root) {
    (root || document).querySelectorAll('[data-mio-pdp]').forEach(function (pdp) {
      if (pdp.__init) return; pdp.__init = true;
      var main = pdp.querySelector('.mio-gallery__main');
      var mainImg = main && main.querySelector('img');
      var thumbs = pdp.querySelectorAll('.mio-thumb');
      var cur = 0;
      function show(k) {
        if (!thumbs.length || !mainImg) return;
        cur = (k + thumbs.length) % thumbs.length;
        var t = thumbs[cur];
        thumbs.forEach(function (x) { x.classList.remove('is-active'); }); t.classList.add('is-active');
        mainImg.classList.add('is-fading');
        setTimeout(function () { mainImg.src = t.getAttribute('data-src'); mainImg.srcset = t.getAttribute('data-srcset') || ''; mainImg.alt = t.getAttribute('data-alt') || ''; mainImg.classList.remove('is-fading'); }, 220);
      }
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
      var pv = pdp.querySelector('[data-gprev]'), nv = pdp.querySelector('[data-gnext]');
      if (pv) pv.addEventListener('click', function (e) { e.stopPropagation(); show(cur - 1); });
      if (nv) nv.addEventListener('click', function (e) { e.stopPropagation(); show(cur + 1); });
      if (main) {
        if (fine) {
          main.addEventListener('pointermove', function (e) {
            if (!main.classList.contains('is-zoom')) return;
            var r = main.getBoundingClientRect();
            main.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100) + '%');
            main.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100) + '%');
          });
          main.addEventListener('pointerenter', function () { main.classList.add('is-zoom'); });
          main.addEventListener('pointerleave', function () { main.classList.remove('is-zoom'); });
        }
        var sx = null;
        main.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1)); sx = null; });
      }

      // variantes
      var dataEl = pdp.querySelector('[data-mio-variants]');
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var idInput = pdp.querySelector('input[name=id]');
      var priceEl = pdp.querySelector('[data-price]'), compareEl = pdp.querySelector('[data-compare]'), saveEl = pdp.querySelector('[data-save]');
      var addBtns = pdp.querySelectorAll('[data-add-btn]');
      var stock = pdp.querySelector('.mio-stock'), stockTxt = stock && stock.querySelector('span');
      var stickyPrice = document.querySelector('[data-sticky-price]');
      var groups = pdp.querySelectorAll('.mio-opt[data-index]');
      var labels = { add: pdp.getAttribute('data-add') || 'Agregar al carrito', sold: pdp.getAttribute('data-sold') || 'Agotado', inStock: pdp.getAttribute('data-instock') || 'En stock', outStock: pdp.getAttribute('data-outstock') || 'Agotado por ahora', save: pdp.getAttribute('data-savetxt') || 'Ahorras' };
      function selected() { var o = []; groups.forEach(function (g) { var a = g.querySelector('.mio-pill.is-active'); o[+g.getAttribute('data-index')] = a ? a.getAttribute('data-value') : null; }); return o; }
      function findV(opts) { return variants.find(function (v) { return v.options.every(function (val, k) { return opts[k] === undefined || opts[k] === null || opts[k] === val; }); }); }
      function markOut() {
        var opts = selected();
        groups.forEach(function (g) {
          var idx = +g.getAttribute('data-index');
          g.querySelectorAll('.mio-pill').forEach(function (p) {
            var test = opts.slice(); test[idx] = p.getAttribute('data-value');
            var v = findV(test); p.classList.toggle('is-out', !v || !v.available);
          });
        });
      }
      function update() {
        var v = findV(selected());
        groups.forEach(function (g) { var a = g.querySelector('.mio-pill.is-active'); var lab = g.querySelector('[data-chosen]'); if (lab && a) lab.textContent = a.getAttribute('data-value'); });
        markOut();
        if (!v) return;
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = money(v.price);
        if (stickyPrice) stickyPrice.textContent = money(v.price);
        if (compareEl) { compareEl.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ''; }
        if (saveEl) { if (v.compare_at_price > v.price) { saveEl.style.display = ''; saveEl.textContent = labels.save + ' ' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%'; } else saveEl.style.display = 'none'; }
        addBtns.forEach(function (b) { b.disabled = !v.available; var s = b.querySelector('span'); (s || b).textContent = v.available ? labels.add : labels.sold; });
        if (stock) { stock.classList.toggle('is-out', !v.available); if (stockTxt) stockTxt.textContent = v.available ? labels.inStock : labels.outStock; }
        if (v.featured_image_index !== null && v.featured_image_index !== undefined && thumbs[v.featured_image_index]) show(v.featured_image_index);
        if (window.history && pdp.getAttribute('data-url')) { try { history.replaceState({}, '', pdp.getAttribute('data-url') + '?variant=' + v.id); } catch (e) {} }
      }
      groups.forEach(function (g) {
        g.querySelectorAll('.mio-pill').forEach(function (p) {
          p.addEventListener('click', function () { g.querySelectorAll('.mio-pill').forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-pressed', 'false'); }); p.classList.add('is-active'); p.setAttribute('aria-pressed', 'true'); update(); });
        });
      });
      if (groups.length) update();

      // cantidad
      var q = pdp.querySelector('.mio-qty input');
      pdp.querySelectorAll('[data-qty]').forEach(function (b) { b.addEventListener('click', function () { q.value = Math.max(1, (+q.value || 1) + (+b.getAttribute('data-qty'))); }); });

      // barra fija móvil
      var sticky = document.querySelector('.mio-sticky');
      var mainBtn = pdp.querySelector('.mio-buy__row');
      if (sticky && mainBtn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { var e = en[0]; sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0); }).observe(mainBtn);
        var sb = sticky.querySelector('button');
        if (sb) sb.addEventListener('click', function () { var f = pdp.querySelector('form[data-mio-add]'); if (f) { if (f.requestSubmit) f.requestSubmit(); else f.dispatchEvent(new Event('submit', { cancelable: true })); } });
      }
    });

    // modal de tallas
    document.querySelectorAll('[data-open-modal]').forEach(function (b) {
      if (b.__init) return; b.__init = true;
      b.addEventListener('click', function () { var m = document.getElementById(b.getAttribute('data-open-modal')); if (m) { m.classList.add('is-open'); initSizer(m); } });
    });
    document.querySelectorAll('.mio-modal').forEach(function (m) {
      if (m.__init) return; m.__init = true;
      m.addEventListener('click', function (e) { if (e.target === m || e.target.closest('.mio-modal__close')) m.classList.remove('is-open'); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') m.classList.remove('is-open'); });
    });
  }

  /* ---------- CTA: parallax de imagen ---------- */
  function initCta() {
    if (reduce) return;
    var imgs = document.querySelectorAll('.mio-cta__img');
    if (!imgs.length) return;
    window.addEventListener('scroll', function () {
      imgs.forEach(function (img) {
        var r = img.parentElement.getBoundingClientRect();
        var p = (r.top + r.height / 2 - window.innerHeight / 2) / window.innerHeight;
        img.style.setProperty('--mio-py', (p * -60).toFixed(1) + 'px');
      });
    }, { passive: true });
  }

  function initAll(root) { initReveal(root); initTilt(root); initHero(root); initGlow(root); initFilters(root); initAjaxAdd(root); initSizer(root); initPdp(root); }
  document.addEventListener('DOMContentLoaded', function () { initAll(document); initCta(); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

(function(){var HV=/[?&]variant=/.test(location.search);function init(){document.querySelectorAll('[data-mio-pdp]').forEach(function(pdp){var groups=[].slice.call(pdp.querySelectorAll('.mio-opt[data-index]'));var g=groups.filter(function(x){var h=x.querySelector('.mio-opt__head');return h&&/talla|size/i.test(h.textContent);})[0];if(!g)return;var form=pdp.querySelector('form[data-mio-add]');var lab=g.querySelector('[data-chosen]');var btns=pdp.querySelectorAll('[data-add-btn]');var msg=document.createElement('p');msg.className='mio-need';msg.textContent='Por favor, elige tu talla';g.appendChild(msg);function chosen(){return !!g.querySelector('.mio-pill.is-active');}function need(){g.classList.remove('is-need');void g.offsetWidth;g.classList.add('is-need');g.scrollIntoView({behavior:'smooth',block:'center'});}function setTxt(){if(chosen())return;btns.forEach(function(b){var s=b.querySelector('span');(s||b).textContent='Elige tu talla';b.disabled=false;});if(lab)lab.textContent='—';}if(!HV){g.querySelectorAll('.mio-pill').forEach(function(p){p.classList.remove('is-active');p.setAttribute('aria-pressed','false');});setTxt();}pdp.addEventListener('click',function(e){if(e.target.closest('.shopify-payment-button')&&!chosen()){e.preventDefault();e.stopPropagation();need();return;}if(e.target.closest('.mio-pill')){setTimeout(function(){if(chosen())g.classList.remove('is-need');setTxt();},0);}},true);document.addEventListener('submit',function(e){if(e.target!==form)return;if(!chosen()){e.preventDefault();e.stopImmediatePropagation();need();}},true);});}var done=false;function go(){if(done)return;done=true;init();}if(document.readyState==='complete')go();else{document.addEventListener('DOMContentLoaded',function(){setTimeout(go,0);});window.addEventListener('load',go);}})();